import { Button, ButtonGroup } from "react-bootstrap";
import "./SegmentedButtons.css";

/**
 * Seletor segmentado: poucas opções lado a lado, ocupando a largura toda, em vez de uma lista.
 *
 * Serve para escolhas de duas ou três opções que precisam ser lidas de uma vez, sem abrir nada:
 * preço e acerto no consumo do colaborador, forma de pagar na regra de comissão. Um componente
 * só para as telas não divergirem de altura, cor e comportamento.
 *
 * @param {Array} options - { value, label, hint?, icon?, disabled?, title? }. O hint aparece
 *        embaixo do rótulo (ex.: o valor que aquela opção cobra).
 * @param {*} value - Valor selecionado.
 * @param {function} onChange - Recebe o value da opção clicada.
 * @param {string} ariaLabel - Nome do grupo para leitores de tela.
 * @param {boolean} compact - Altura de campo de formulário, com o ícone ao lado do rótulo. Para
 *        ficar na mesma linha de outros campos; sem hint, que não cabe nessa altura.
 */
const SegmentedButtons = ({ options, value, onChange, ariaLabel, className = '', compact = false }) => (
    <ButtonGroup className={`segmented-buttons ${compact ? 'segmented-buttons--compact' : ''} ${className}`.trim()}
        aria-label={ariaLabel}>
        {options.map(option => {
            const selected = value === option.value;
            return (
                <Button
                    key={option.value}
                    type="button"
                    // Preenchido só o selecionado; os demais apenas contornados. Primary e primary
                    // light ficavam parecidos demais no tema escuro.
                    variant={selected ? 'primary' : 'outline-primary'}
                    active={selected}
                    aria-pressed={selected}
                    disabled={option.disabled}
                    title={option.title}
                    onClick={() => onChange(option.value)}
                >
                    {option.icon && <i className={option.icon} aria-hidden="true"></i>}
                    <span>{option.label}</span>
                    {option.hint && <small>{option.hint}</small>}
                </Button>
            );
        })}
    </ButtonGroup>
);

export default SegmentedButtons;
